import Promise from 'bluebird';

const MAX_POLL_ATTEMPTS = 120;
const POLL_INTERVAL_TIMEOUT = 5000;

export class PollTask {
  /**
   * Create a poll task
   * @param {Function} task - task need to be polled
   * @param {Function} isCompleted - Function to check if task completed.
   * @param {Function} isFailed - Function to check if task failed.
   * @param {Object} asyncScheduler - asyncScheduler library.
   * @param {number} maxPollCount - Max number of times to poll.
   * @param {number} pollIntervalTimeout - poll interval
   * @returns {Promise} Resolves to the rawData of apply result.
   */
  constructor(
    task,
    isCompleted,
    isFailed,
    asyncScheduler,
    maxPollCount = MAX_POLL_ATTEMPTS,
    pollIntervalTimeout = POLL_INTERVAL_TIMEOUT
  ) {
    this.pollCount = 0;
    this.maxPollCount = maxPollCount;

    // Define task and event handler
    this.recurringTask = asyncScheduler.createTask({
      task,
      schedule: pollIntervalTimeout,
    });
    this.isCompleted = isCompleted;
    this.isFailed = isFailed;
  }

  start = () => new Promise((resolve, reject) => {
    this.recurringTask.on('success', ({
      data,
      stopTask,
    }) => {
      this.pollCount += 1;
      if (this.pollCount > this.maxPollCount) {
        stopTask();
        reject(new Error('Poll Limit Reached'));
        return;
      }

      if (data) {
        if (this.isCompleted(data)) {
          stopTask();
          resolve(data);
        } else if (this.isFailed(data)) {
          stopTask();
          reject(new Error('Internal Error'));
        }
      }
    });

    this.recurringTask.on('error', ({
      error,
      stopTask,
    }) => {
      stopTask();
      reject(error);
    });

    this.recurringTask.on('manuallyStopped', () => {
      resolve();
    });

    this.recurringTask.start();
  })

  stop = () => {
    this.recurringTask.stop();
    this.recurringTask.trigger('manuallyStopped');
  }
}
